import React from "react";

/* More-menu row: icon + label (left group), shortcut right (muted). */
const ToolbarMoreMenuRow = ({
  label,
  shortcut,
  onClick,
  onMouseOver,
  onMouseLeave,
  className = "",
  disabled = false,
  children,
}) => {
  return (
    <div
      className={`viewer-toolbar-more-menu-row ${className}`.trim()}
      onClick={onClick}
      onMouseOver={onMouseOver}
      onMouseLeave={onMouseLeave}
      role="presentation"
      style={
        disabled ? { opacity: 0.5, pointerEvents: "none" } : undefined
      }
    >
      <div className="viewer-toolbar-more-menu-leading">
        <div className="viewer-toolbar-more-menu-icon">{children}</div>
        <span className="viewer-toolbar-more-menu-label">{label}</span>
      </div>
      {shortcut ? (
        <span className="viewer-toolbar-more-menu-shortcut">{shortcut}</span>
      ) : null}
    </div>
  );
};

export default ToolbarMoreMenuRow;
